import { createContext } from 'react';


const FormNameContext = createContext(null);

export default FormNameContext;
